import styled from 'styled-components'

const List = styled.ol`
  list-style-type: none;
  margin-block-start: 0;
  border-top: 3px solid lightgrey;
  padding-inline-start: 0;
`
export default List;
